<template>
    <div>
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <card header-classes="bg-transparent" body-classes="bg-transparent py-0">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-muted text-uppercase ls-1 mb-1">Overview</h6>
                                <h6 class="h4 mb-0" style="color: #3a3f43;">AKTIVITAS</h6>
                            </div>
                        </div>
                        <div v-if="overview.brc_on_class_list && overview.brc_on_class_list.length > 0">
                            <div v-for="(item, index) in overview.brc_on_class_list" :key="index" class="card my-4">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <div class="left-content">
                                        <div class="user-article">
                                            <a href="javascript:void(0);" class="text-uppercase font-weight-bold">{{ item.full_name }}</a>&nbsp;
                                            <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>&nbsp;
                                            <a href="javascript:void(0);" class="text-uppercase font-weight-bold">{{ item.user_class }}</a>
                                        </div>
                                        <div class="role-article">
                                            <small class="text-muted">{{ item.type }} - {{ item.created }}</small>
                                        </div>
                                    </div>
                                    <div class="left-content" v-if="item.is_me">
                                        <a href="javascript:void(0)" class="icon-clicked" @click="confirmDeleteStatus(item.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <p class="">{{ item.status }}</p>
                                    <img v-if="item.is_file==1&&item.file_path"
                                        class="img-center-200-x"
                                        width="100"
                                        :src="item.file_path"
                                        alt="Logo"
                                    />
                                </div>
                            </div>
                        </div>
                        <div v-else class="p-2 text-center text-muted">
                            Aktivitas Tidak Ditemukan
                        </div>
                    </card>
                </div>

                <div class="col-xl-4">
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-uppercase ls-1 mb-1">INFO</h6>
                            </div>
                        </div>
                        <div class="identity px-2">
                            <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{user.full_name}}</p>
                            <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{user.user_status}}</p>
                            <p class="line-with-icon"><i class="clr-red fa fa-envelope" aria-hidden="true"></i>{{user.email}}</p>
                            <p v-if="user.district_view !== null" class="line-with-icon"><i class="clr-red fa fa-map-marker" aria-hidden="true"></i>{{user.district_view}}</p>
                            <p class="line-with-icon"><i class="clr-red fa fa-calendar" aria-hidden="true"></i>{{user.created}}</p>
                        </div>
                        <hr>
                        <div v-if="user.type == 'murid'" class="class-followed text-center px-2">
                            <h6>{{overview.total_class}}</h6>
                            Kelas yang diikuti
                        </div>
                        <div v-else class="card class-followed text-center">
                            <div class="card-header font-weight-bold">
                                Mengampu
                            </div>
                            <div class="card-body">
                            <h6>{{overview.total_class}}</h6>
                            <p>KELAS</p>
                            </div>
                        </div>
                    </card>
                    <card header-classes="bg-transparent" class="mt-4">
                        <div slot="header" class="row align-items-center">
                            <div class="d-flex justify-content-between" style="align-items: center;">
                                <div>
                                    <h6 class="text-uppercase ls-1 mb-1">DAFTAR KELAS</h6>
                                </div>
                                <div class="" v-if="user.type == 'admin'">
                                    <select class="form-select form-select-sm" v-model="filter_form.tahun_ajaran_id">
                                        <option v-for="item in setTaList" :key="item.id" :value="item.id">{{ item.name }}</option>
                                    </select>
                                </div>
                                <div>
                                    <b-dropdown id="dropdown-1" right text="AKSI" size="sm" class="m-md-2">
                                        <b-dropdown-item v-if="user.type == 'tutor' || user.type == 'admin'" @click="showAddClassModal"><i class="fa fa-plus-circle" aria-hidden="true"></i>Tambah Kelas</b-dropdown-item>
                                        <b-dropdown-item v-if="user.type == 'tutor' || user.type == 'admin'">
                                            <i class="fa fa-cogs" aria-hidden="true"></i>
                                            <router-link :to="{ name: 'class-list'}" class="text-black">Kelola Kelas</router-link>
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="showJoinClassModal"><i class="fa fa-user-plus" aria-hidden="true"></i>Gabung Kelas</b-dropdown-item>
                                    </b-dropdown>   
                                </div>
                            </div>
                        </div>
                        <div class="class-list px-2">
                            <p v-for="(item, index) in classList" :key="index" class="line-with-icon">
                                <i class="fa fa-folder clr-red" aria-hidden="true"></i>
                                <router-link :to="{ name: 'class-detail', params: { classId: item.id,taId:filter_form.tahun_ajaran_id }}">{{item.name}}</router-link>
                                <br>
                                <sup><b>-- {{item.status}} --</b></sup>
                            </p>
                        </div>
                    </card>
                </div>
            </div>
        </div>
		<b-modal
			ref="new-class-modal"
			class="new-class-modal"
			size="md"
            title="Tambah Kelas Baru"
            @show="resetNewClassModal"
            @hidden="resetNewClassModal"
			hide-footer
			no-close-on-backdrop
		>
            <div class="new-class-body">
                <b-form data-vv-scope="new-class-form">
                    <b-row class="kelas">
                        <b-col sm="3">
                            <label for="input-nama-kelas">Nama Kelas</label>
                        </b-col>
                        <b-col sm="9">
                            <b-form-input
                            id="input-nama-kelas"
                            name="class_name"
                            data-vv-as="Nama kelas"
                            v-model="add_class_form.name"
                            type="text"
                            placeholder="Nama Kelas Baru"
                            v-validate="'required'"
                            autocomplete="off"
                            ></b-form-input>
                            <span :class="{ 'error-validation': errors.first('new-class-form.class_name') }">{{ errors.first('new-class-form.class_name') }}</span>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
            <hr>
            <div class="new-class-footer d-flex justify-content-end">
                <b-button variant="outline-danger" size="md" style="width: 25%;" @click="hideAddClassModal">BATAL</b-button>
                <b-button variant="primary" size="md" style="width: 25%;" @click.prevent="saveNewClass">SIMPAN</b-button>
            </div>
		</b-modal>
		<b-modal
			ref="join-class-modal"
			class="join-class-modal"
			size="md"
            title="Bergabung Kelas"
            @show="resetJoinClassModal"
            @hidden="resetJoinClassModal"
			hide-footer
			no-close-on-backdrop
		>
            <join-class-form></join-class-form>
		</b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
	import JoinClassForm from "../../components/Main/JoinClassForm";
    export default {
        components: {
            JoinClassForm
        },
        data() {
            return {
                add_class_form: {
                    name: null
                },
                filter_form: {
                    tahun_ajaran_id: null,
                },
                setTaList : []
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                classList: 'getClassList',
                overview: 'getOverview',
                taList: 'getTaList'
            })
        },
        methods: {
            showAddClassModal() {
                this.$refs['new-class-modal'].show()
            },
            hideAddClassModal() {
                this.$refs['new-class-modal'].hide()
                this.resetNewClassModal()
            },
            showJoinClassModal() {
                this.$refs['join-class-modal'].show()
            },
            hideJoinClassModal() {
                this.$refs['join-class-modal'].hide()
                this.resetJoinClassModal()
            },
            resetJoinClassModal() {
                EventBus.$emit('resetJoinClassForm', true)
            },
            resetNewClassModal() {
                this.add_class_form.name = null
                this.$validator.reset()
            },
            async getTaList() {
                this.isBusy = true
				await this.$store.dispatch('getTaList')
					.then((res) => {
                        for(var i=0; i<res[0].data.data.length;i++){   
                            var tmp = res[0].data.data[i];
                            tmp.id = encodeURIComponent(window.btoa(res[0].data.data[i].id));
                            this.setTaList.push(tmp);
                        }
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async saveNewClass() {
                // this.showLoader = true
                let scope = 'new-class-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        let name = this.add_class_form.name 
						this.$store.dispatch('addClass', { name })
							.then((res) => {
								// this.showLoader = false
                                this.getClassList()
                                this.getOverview()
                                this.hideAddClassModal()
                                this.$swal.fire('Success', res.message, 'success')
							})
							.catch((err)=> {
								// this.showLoader = false
                                this.$swal.fire('Failed', err.response.data.message, 'error')
							})
                    }
                });
            },
			async getClassList () {
				await this.$store.dispatch('getClassList')
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async getOverview () {
				await this.$store.dispatch('getOverview')
					.then((res) => {
                        this.filter_form.tahun_ajaran_id = encodeURIComponent(window.btoa(res.data.data.current_ta_id))
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async deleteStatus(id) {
                let form = {
                    status_id: id
                }
                await this.$store.dispatch('deleteStatus', form)
                    .then((res) => {
                        this.getOverview()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        this.$swal.fire('Failed', err.response.data.message, 'error')
                    })
            },
            async confirmDeleteStatus(id) {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.deleteStatus(id)
                    }
                })
            }
        },
        mounted() {
        },
        async created() {
            // EventBus.$emit('showLoader', true)
            await this.getClassList()
            await this.getOverview()
            await this.getTaList()
            // EventBus.$emit('hideLoader', true)
            EventBus.$on('hideJoinClassModal', (val) => {
                if (val) {
					this.hideJoinClassModal()
                }
            })
            EventBus.$on('showJoinClassModal', (val) => {
                if (val) {
					this.showJoinClassModal()
                }
            })
        }
    };
</script>
<style lang="css" scoped>
.line-with-icon svg {
    /* color: #adb7be; */
    position: absolute;
    left: 0;
    top: 0;
    font-size: 1rem;
}
.line-with-icon {
    position: relative;
    padding: 0 0 0 1.75em;
    margin: 0 0 1em;
}
.user-article a {
    color: black;
}
.class-list > .line-with-icon > a{
    color:#ca062a
}
.user-article a:hover {
    color: #ca062a;
}
</style>